"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const helpers_1 = require("../helpers");
function markerVisitor(path) {
    const { leadingComments } = path.node;
    if (leadingComments && leadingComments.length > 0 &&
        helpers_1.isStopifyAnnotation(leadingComments[leadingComments.length - 1].value.trim())) {
        path.node.mark = 'Flat';
    }
}
const visitor = {
    CallExpression: markerVisitor,
    NewExpression: markerVisitor,
    FunctionDeclaration: markerVisitor,
    FunctionExpression: markerVisitor
};
function markAnnotated() {
    return { visitor };
}
exports.markAnnotated = markAnnotated;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWFya0Fubm90YXRlZC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21waWxlci9tYXJrQW5ub3RhdGVkLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBRUEsd0NBQStEO0FBRS9ELFNBQVMsYUFBYSxDQUFDLElBQXlHO0lBQzVILE1BQU0sRUFBRSxlQUFlLEVBQUUsR0FBRyxJQUFJLENBQUMsSUFBSSxDQUFDO0lBQ3RDLElBQUksZUFBZSxJQUFJLGVBQWUsQ0FBQyxNQUFNLEdBQUcsQ0FBQztRQUM3Qyw2QkFBbUIsQ0FDakIsZUFBZSxDQUFDLGVBQWUsQ0FBQyxNQUFNLEdBQUcsQ0FBQyxDQUFDLENBQUMsS0FBSyxDQUFDLElBQUksRUFBRSxDQUFDLEVBQUU7UUFDL0QsSUFBSSxDQUFDLElBQUksQ0FBQyxJQUFJLEdBQUcsTUFBTSxDQUFDO0tBQ3pCO0FBQ0wsQ0FBQztBQUVELE1BQU0sT0FBTyxHQUFHO0lBQ2QsY0FBYyxFQUFFLGFBQWE7SUFDN0IsYUFBYSxFQUFFLGFBQWE7SUFDNUIsbUJBQW1CLEVBQUUsYUFBYTtJQUNsQyxrQkFBa0IsRUFBRSxhQUFhO0NBQ2xDLENBQUM7QUFFRixTQUFnQixhQUFhO0lBQ3pCLE9BQU8sRUFBRSxPQUFPLEVBQUUsQ0FBQztBQUN2QixDQUFDO0FBRkQsc0NBRUMifQ==


//////////////////
// WEBPACK FOOTER
// .-continuations-compiler/dist/src/compiler/markAnnotated.js
// module id = 809
// module chunks = 0